(function () {
    'use strict';

    angular.module('swif.fluid')

    .controller('FluidStatisticsController',
        function ($scope, swif) {
            'ngInject';
            console.log('init FluidStatisticsController');

            $scope.pieChartOptions = {
                chart: {
                    type: 'pieChart',
                    height: 400,
                    x: function(d){return d.key;},
                    y: function(d){return d.y;},
                    showLabels: true,
                    duration: 500,
                    labelThreshold: 0.01,
                    labelSunbeamLayout: true,
                    legendPosition: 'right',
                    tooltip: {
                        contentGenerator: function (e) {
                            var series = e.series[0];
                            if (series.value === null) return;
                            var typeToSuffix = {currency: '&euro;', hours: 'h'};
                            return "<h4>" + series.key + "</h4>" +
                                "<p>" +  series.value + (typeToSuffix[$scope.getSelectedWhat().type] || '')+ "</p>";
                        }
                    }
                }
            };

            $scope.lineChartOptions = {
                chart: {
                    type: 'lineChart',
                    height: 400,
                    margin: {
                        left: 50,
                        right: 50
                    },
                    useInteractiveGuideline: true,
                    x: function(d){
                        return d.x;
                    },
                    y: function(d){
                        return d.y;
                    },
                    xAxis: {
                        tickFormat: function (d) {
                            return d3.time.format('%m/%Y')(new Date(d));
                        }
                    },
                    yAxis: {
                        tickFormat: function (d) {
                            return d3.format(',f')(d).replace(',',' ') + '€';
                        }
                    },
                    tooltip: {
                        contentGenerator: function (e) {
                            if (_.isUndefined(e.data)) return;
                            var dx = e.data.x;
                            if (dx > 0) {
                                dx = d3.time.format('%m/%Y')(new Date(dx))
                            }
                            // return function(key, x, y) {
                            //     return '<h3>' + key + '</h3>' +
                            //         '<p>' +  y + ' &euro; le ' + x + '</p>';
                            // };
                            var ytest = d3.format(',f')(e.data.y).replace(',',' ') + 'h';
                            return "<p>" +  ytest + " le " + dx + "</p>";
                        }
                    }
                }
            };


            var update = function () {
                var waterData = {key: swif.i18n.getString('Water'), values: []};
                var gazData = {key: swif.i18n.getString('Gaz'), values: []};
                var elecData = {key: swif.i18n.getString('Electricity'), values: []};
                var fuelData = {key: swif.i18n.getString('Fuel'), values: []};
                var phoneData = {key: swif.i18n.getString('Phone'), values: []};
                var lineChartData = {
                    water: waterData,
                    gaz: gazData,
                    electricity: elecData,
                    fuel: fuelData,
                    phone: phoneData
                };
                var item;
                for (var i = 0; i < $scope.items.length; i++) {
                    item = $scope.items[i];
                    lineChartData[item.type[0]].values.push([new Date(item.date_start), item.cost]);
                }

                $scope.lineChartData = [];
                $scope.pieChartData = [];

                _.forOwn(lineChartData, function (v) {
                    if (v.values.length > 0) {
                        $scope.lineChartData.push(v);
                        var sum = v.values.reduce(function(pv, cv) {
                            return pv + cv[1];
                        }, 0);
                        $scope.pieChartData.push({key: v.key, y: sum});
                    }
                });
            };
            $scope.$watch('$parent.items', function (newV) {
                if (newV !== undefined) {
                    update();
                }
            },true);
        }
    );


})();
